import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import appIcon from "../assets/company-logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="logos">
        <img src={appIcon} alt="Company Logo"/>
      </div>
      <div className="footer-links">
        <Link to="/maqs/privacy-policy" className="footer-link">
          Privacy Policy
        </Link>{" "}
        |{" "}
        <Link to="/maqs/terms-and-conditions" className="footer-link">
          T&C
        </Link>{" "}
        |{" "}
        <Link to="/maqs/eula" className="footer-link">
          EULA
        </Link>
        <p>Copyright 2025 @ All Rights Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;